export const IMAGE_TEXT_MODULE_TEST_ID = {
  section: 'image-text-module-section',
};
